import FontFaceDropdown from './FontFaceDropdown';

export default FontFaceDropdown;